class Node {
	constructor(value) {
		this.reset(value);
	}
	reset(value) {
		this.value = value;
		this.next = null;
	}
}

export class Queue {
	constructor() {
		this.first = null;
		this.last = null;
		this.free = null;
		this.size = 0;
	}

	#getNode(value) {
		let newNode;
		if (this.free) {
			newNode = this.free;
			this.free = this.free.next;
			newNode.reset(value);
		} else {
			newNode = new Node(value);
		}

		return newNode;
	}

	#freeNode(node) {
		node.next = this.free;
		node.value = null;
		this.free = node;
	}

	enqueue(value) {

		const newNode = this.#getNode(value);

		if (!this.first) {
			this.first = newNode;
			this.last = newNode;
		} else {
			this.last.next = newNode;
			this.last = newNode;
		}
		this.size++;
		return this.size;
	}

	dequeue() {
		if (!this.first) return null;
		const temp = this.first;
		if (this.first === this.last) {
			this.last = null;
		}
		this.first = this.first.next;
		this.size--;

		const res = temp.value;
		this.#freeNode(temp);
		return res;
	}

	peek() {
		if (!this.first) return null;
		return this.first.value;
	}

	isEmpty() {
		return this.size === 0;
	}

	getSize() {
		return this.size;
	}

	forEach(callback) {
		let current = this.first;
		while (current) {
			callback(current.value);
			current = current.next;
		}
	}
}
